export const demoKeys = {
  clubs: 'livroom-v4-demo-clubs',
  projects: 'livroom-v4-demo-projects',
  chapters: 'livroom-v4-demo-chapters',
  friendships: 'livroom-v4-demo-friendships',
  readingCircles: 'livroom-v4-demo-reading-circles',
  annotations: 'livroom-v4-demo-annotations',
  profile: 'livroom-v4-demo-profile'
} as const

export function readStored<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(key)
    return raw ? JSON.parse(raw) as T : fallback
  } catch {
    return fallback
  }
}

export function writeStored<T>(key: string, value: T) {
  localStorage.setItem(key, JSON.stringify(value))
  window.dispatchEvent(new CustomEvent('livroom:store', { detail: { key } }))
}

export function makeId(prefix: string) {
  const id = globalThis.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(16).slice(2)}`
  return `${prefix}-${id}`
}

export function wordCount(value: string) {
  const normalized = value.trim()
  return normalized ? normalized.split(/\s+/).length : 0
}

export function slugify(value: string) {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '')
}
